import { html, unsafeCSS } from "lit";
import { nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./dropdown-group.css?inline";
import "@/components/paragraph";

@customElement("eko-dropdown-group")
export class DropdownGroup extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) divider: boolean = false;
  @property() heading: string = "";

  render() {
    return html`
      ${this.heading
        ? html`<eko-paragraph
            size="sm"
            weight="semibold"
            class="eko-dropdown-group__heading"
            part="heading"
            >${this.heading}</eko-paragraph
          >`
        : nothing}
      <slot class="eko-dropdown-group__content"></slot>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-dropdown-group": DropdownGroup;
  }
}

export default DropdownGroup;
